import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-condition',
  templateUrl: './sales-condition.component.html',
  styleUrls: ['./sales-condition.component.css']
})
export class SalesConditionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
